export default {
  about_this_app: 'About this app',
  activate_users: 'Activate user(s)',
  active: 'Active',
  active_filters: '{{number}} filter active',
  address: 'Address',
  add_gym: 'Add gym',
  add_player: 'Add player',
  add_players: 'Add players',
  add_team: 'Add team',
  add_user: 'Add User',
  add_widget: 'Add widget',
  admin: 'Admin',
  administration: 'Administration',
  age: {
    title: 'Age',
    min: 'Minimum age',
    max: 'Maximum age',
    team_settings: {
      info: 'Here you can set the age group of your team. The setting will be used to automatically assign interested persons to the appropriate team.',
    },
  },
  agb: 'Terms and conditions',
  all_coaches: 'All coaches',
  all_players: 'All players',
  all_referees: 'all referees',
  archive: 'Archive',
  association: 'Association',
  at_away_games: 'At away games',
  at_home_games: 'At home games',
  at_practices: 'At practices',
  audit_types: {
    canceled: 'Canceled',
    car_id: 'Car',
    date: 'Date',
    end_date: 'End',
    description: 'Description',
    name: 'Name',
    home: 'Home',
    guest: 'Guest',
    status: 'Status',
    location: 'Location',
    gym: 'Gym',
    gym_address: 'Address',
    jerseys: 'Jerseys',
    judge_team_id: 'Judge team',
    judge_paper_id: 'Judge person 1',
    judge_time_id: 'Judge person 2',
    judge_24sec_id: 'Judge person 3',
    judge_paper_asst_id: 'Judge person 4',
    own_referee1: 'Referee 1',
    own_referee2: 'Referee 2',
    own_referee1_id: 'Referee 1',
    own_referee2_id: 'Referee 2',
    responsible_user_id: 'Responsible person',
    referee_1: 'Referee 1',
    referee_2: 'Referee 2',
    scheduled: 'Scheduled',
    meet_at: 'Meet at',
    meet_at_location: 'Meeting point',
  },
  auto: 'Auto',
  available: 'Available',
  away_game: 'Away game',
  away_games: 'Away games',
  back: 'Back',
  back_to_login: 'Back to login',
  birthday: 'Birthday',
  calendar: 'Calendar',
  cancel: 'Cancel',
  cancellations: 'No',
  canceled: 'Canceled',
  captain: 'Captain',
  cars: {
    singular: 'Vehicle',
    plural: 'Vehicles',
    create: 'Create vehicle',
    edit: 'Update vehicle',
    delete: 'Delete vehicle',
    carpool: 'Carpool',
    drivers_licence: 'Drivers licence',
    environment_badge: 'Environment badge',
    fuel: 'Fuel type',
    licence_plate: 'Licence plate',
    reservable: 'Reservable',
    reservations: {
      title: 'Vehicle reservations',
      add: 'Create vehicle reservation',
      edit: 'Edit vehicle reservation',
      delete: 'Delete vehicle reservation',
      external: 'External reservation',
      more: 'More vehicle reservations',
      more_info:
        'Discover more vehicle reservations for this vehicle the day before and after this game.',
      fields: {
        destination: 'Destination',
      },
      time_range: {
        from: 'From {{time}}',
        to: 'Until {{time}}',
        all_day: 'All day',
      },
    },
    game_info: {
      title: 'Vehicle information',
      admin_popup: {
        description: 'What would you like to do?',
        update: 'Edit vehicles',
        view: 'Show vehicle details',
      },
    },
  },
  change_answer: 'Change answer',
  changelog: 'Changelog',
  city: 'City',
  close: 'Close',
  club: 'Club',
  club_details: 'Club details',
  club_games: 'Club games',
  club_settings: {
    functions: {
      title: 'Functions',
      items: {
        partners: {
          title: 'Partners',
          description:
            'Management of partners and sponsors including the creation of partner content such as news or benefits for members.',
        },
      },
    },
  },
  clubs: 'Clubs',
  coach: 'Coach',
  coaches: 'Coaches',
  coach_conflicts: 'Coach conflicts',
  coach_logging: 'Coach logging',
  collapse: 'Collapse',
  color: 'Color',
  comments: {
    singular: 'Comment',
    plural: 'Comments',
    number_of_comments_text_one: '{{count}} comment available',
    number_of_comments_text_other: '{{count}} comments available',
    last_comment_text: 'Latest comment by {{name}} at {{date}}',
    comment_as: 'Comment as',
  },
  commitments: 'Yes',
  completed: 'Completed',
  confirm: 'Confirm',
  contact: 'Contact',
  contacts: 'Contacts',
  countdown: {
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
  },
  country: 'Country',
  create_request: 'Create request',
  created_at: 'Created at',
  crud: {
    image: {
      edit: 'Edit',
      upload: 'Upload',
    },
  },
  current_games: 'Current games',
  custom_user_attributes: {
    title: 'Custom user attributes',
    date: 'Date',
    email: 'E-Mail',
    multi_email: 'E-Mail list',
    number: 'Number',
    sex: 'Sex',
    text: 'Text',
  },
  dashboard: 'Dashboard',
  data_processing: {
    title: 'Data Processing',
    accepted_agreement_with_version:
      'Accepted Data Processing Agreement (Version {{version}})',
    accepted_agreements_singular:
      'A data processing agreement was successfully completed on {{date}}.',
    accepted_agreements_plural:
      'A data processing agreement was first completed on {{first}} and last completed on {{latest}}.',
    agreement: 'Data Processing Agreement',
    agreement_with_version: 'Data Processing Agreement (Version {{version}})',
    agree_disclamer_text: 'I have read the Data Processing Agreement.',
    agree_button: 'Accept Agreement',
    no_accepted_agreements: 'Please accept the agreement to use Backcourt.',
  },
  date: 'Date',
  default: 'Default',
  delete: 'Delete',
  delete_player: 'Delete player',
  delete_players: 'Delete players',
  delete_users: 'Delete user(s)',
  description: 'Description',
  deselect_all: 'Deselect all',
  details: 'Details',
  download_csv: 'Download CSV',
  duplicate: 'Duplicate',
  duration: 'Duration',
  edit: 'Edit',
  edit_player: 'Edit player',
  edit_team: 'Edit team',
  edit_user: 'Edit user',
  edited: 'Edited',
  email: 'E-Mail address',
  end: 'End',
  error: 'Error',
  event: 'Event',
  event_type: 'Event type',
  event_types: {
    '0': 'Game',
    '1': 'Practice',
  },
  event_roles: {
    '0': 'Player',
    '1': 'Coach',
    '2': 'Referee',
    '3': 'Supervisor',
    '4': 'Judge',
    '5': 'Jerseys',
    '6': 'Custom',
  },
  events: 'Events',
  expand: 'Expand',
  feed: {
    basketball_game_comment: {
      header: 'commented on the game',
    },
    basketball_game_result: {
      title: 'Game Result',
    },
    basketball_practice_comment: {
      header: 'commented on the practice',
    },
    birthday: {
      header: 'is celebrating their {{number}}th birthday today',
      text: 'Happy Birthday!',
    },
    event_comment: {
      header: 'commented on the event',
    },
    event_report: {
      header: 'created a game report',
    },
  },
  filter: 'Filter',
  filter_and_more: 'Filters and more',
  finished: 'Finished',
  firstname: 'Firstname',
  from: 'From',
  full_age: 'Full age',
  game: 'Game',
  gameday_planer: {
    title: 'Game day planning',
    current_week: 'Current week',
    own_times: 'Own times',
    show_tasks: 'Show tasks',
    time_pending: 'The time has not yet been determined!',
  },
  game_details: 'Game details',
  game_reports: {
    singular: 'Game Report',
    plural: 'Game Reports',
    add: 'Add Game Report',
    edit: 'Edit Game Report',
    delete: 'Delete Game Report',
    generate: {
      privacy: {
        title: 'Privacy',
        description:
          'Our software gives you the option to generate game reports using the OpenAI API. This feature is completely optional and will only be activated with your explicit consent.',
        data_transfer:
          'When using the game report feature, the texts and information you enter will be sent to the OpenAI API. OpenAI processes this data to generate the requested game reports. The data may be temporarily stored in the USA, where privacy laws may not provide the same level of protection as in the EU.',
        consent:
          'The use of the feature and data transmission is based solely on your explicit consent in accordance with Art. 6, Para. 1, lit. a GDPR.',
        data_transfer_info:
          'Please note that using OpenAI involves data transmission to a third country where privacy laws may not be equivalent to EU standards.',
        voluntary:
          'The use of this feature is voluntary. You can disable it at any time by not using the feature.',
        more_info:
          "For more information on data processing by OpenAI, please see OpenAI's privacy policy: https://www.openai.com/privacy",
      },
      wizard: {
        title: 'Generate Game Report',
        steps: {
          game_details: {
            button_next: 'Next',
            final_score: 'Final Score',
            overtime: {
              title: 'Overtime',
              add: 'Add Overtime',
              remove: 'Remove Overtime',
            },
            quarter: 'Quarter',
            special_events: 'Special Events',
            title: 'Game Information',
          },
          general: {
            button_next: 'Next',
            info: 'You can leave fields blank in the upcoming steps if you don’t wish to fill them out. Those fields will be ignored.',
            privacy: {
              description:
                'I consent to the transmission of the data I entered to the OpenAI API in order to generate a game report. I am aware that processing by OpenAI occurs in the USA, and potential privacy risks may exist.',
              link: 'Privacy Policy',
            },
            public: {
              title: 'Public',
              description:
                'Public game reports are visible in the press center to everyone (including external people). Private game reports are visible only to club members.',
            },
            title: 'General',
            type: {
              title: 'Type',
              pre: 'Pre-Game Report',
              post: 'Game Report',
            },
            writing_type: {
              neutral: 'Neutral',
              title: 'Writing Style',
              description:
                'The writing style indicates whether the report is neutral or written for a specific team. This is indicated in public reports.',
            },
          },
          pregame: {
            button_next: 'Next',
            title: 'Pre-Game Report',
            additional_info: 'Additional Information',
          },
          preview: {
            button_next: 'Save',
            title: 'Preview',
            report_title: 'Title',
            report_text: 'Text',
            loading: {
              '1': 'The sports journalist is hammering away at the keys...',
              '2': 'The sports journalist is typing away eagerly...',
              '3': 'The sports journalist is deep in thought...',
              '4': 'The keyboard keys are practically glowing...',
              '5': 'Ideas are just bursting forth...',
              '6': 'Creativity knows no bounds...',
              '7': 'Thoughts are flying across the keyboard...',
            },
          },
          summary: {
            button_next: 'Generate',
            title: 'Summary',
            game_summary: 'Game Summary',
            top_performer: {
              title: 'Top Performer',
              description:
                'Which player had the greatest impact on the game and why? Keywords are enough. Max. 200 characters.',
            },
          },
        },
      },
    },
    manual: {
      title: 'Write Game Report',
      form: {
        public: {
          title: 'Public',
          description:
            'Public game reports are visible in the press center to everyone (including external people). Private game reports are visible only to club members.',
        },
        text: 'Text',
        title: 'Title',
        type: {
          title: 'Type',
          pre: 'Pre-Game Report',
          post: 'Game Report',
        },
        writing_type: {
          neutral: 'Neutral',
          title: 'Writing Style',
          description:
            'The writing style indicates whether the report is neutral or written for a specific team. This is indicated in public reports.',
        },
      },
    },
    new_game_report_button: {
      cancel: 'Cancel',
      description: {
        question: 'Would you like to write or generate a game report?',
        upgrade:
          'Upgrade now to the Bundesliga package to automatically generate game reports!',
      },
      generate: 'Generate (Beta)',
      title: 'Create Game Report',
      write: 'Write',
    },
    select_game: {
      title: 'Select Game',
      no_data: {
        title: 'No Games Available',
        description:
          'No games were found in the period from 3 weeks ago to 3 weeks from now.',
      },
    },
    type: {
      pre: 'Preview',
      post: 'Game Report',
    },
    no_data: {
      title: 'No Game Reports Available',
      description: 'No game reports have been created yet.',
      description_admin_coach:
        'No game reports have been created for this game yet. Add a report now via the Press Center.',
    },
  },
  games: {
    singular: 'Game',
    plural: 'Games',
    add: 'Add game',
    add_team: 'Add {{team}}-game',
    canceled: 'This game was canceled.',
    edit: 'Edit game',
    delete: 'Delete game',
    details: 'Game details',
    number: 'Game number',
    errors: {
      managed_by_association:
        'This game is part of a league and managed by the association',
      same_team: 'Please do not select the same team',
      select_active_coach_team:
        'Please choose the active team as a home or guest team',
    },
    form: {
      external_info:
        'Choose two external teams if this game is an external game. This is the case if internal referees are scheduled for this game or if the game takes place in a separate gym with an internal judge.',
      own_club_apponent: 'Internal opponent',
    },
    other_games: {
      same_day: {
        title: 'Other games on the same day in the same gym',
        title_short: 'Day view',
        description:
          'Discover the other games happening on the same day in this gym.',
        navigate_info: {
          title: 'Open game',
          description:
            'Do you want to open the details of this game? The current detail view will be closed.',
        },
      },
    },
  },
  general: 'General',
  generate: 'Generate',
  go_to_web: 'Open web version',
  guest: 'Guest',
  gym: 'Gym',
  gyms: {
    singular: 'Gym',
    plural: 'Gyms',
    add: 'Add gym',
    edit: 'Edit gym',
    delete: 'Delete gym',
    address: 'Gym address',
    responsible_person_long: 'Responsible person',
    responsible_person_short: 'Responsibility',
    color: {
      description: 'The color is used in the calendar views.',
    },
    closures: {
      title: 'Gym Closure Times',
      add: 'Add Gym Closure Time',
      edit: 'Edit Gym Closure Time',
      delete: 'Delete Gym Closure Time',
      affected: 'Affected gyms: {{gyms}}',
      alert: {
        mobile: {
          info: 'Gym closures are expected in the next seven days. Tap here for current information on the affected gyms and exact closure times.',
        },
      },
      reason: 'Reason',
      practice_sync_info:
        "Don't forget to synchronize the practice sessions after saving to ensure that the gym closure times are taken into account. You can perform the synchronization in the practice management.",
      vacations: {
        title: 'Holidays',
        sync: {
          title: 'Synchronize Holidays',
          description:
            'Automatically add gym closure times for the holidays in your state. Select a date up to which the holidays should be synchronized. You can edit the data after selecting the date before saving.',
        },
        description: 'The gym is closed during this time.',
      },
    },
  },
  handicap: 'Handicap',
  help: 'Help',
  helpouts: {
    title: 'Stand-Ins',
    none: 'No stand-ins',
    number_of_helpouts_one: 'One stand-in',
    number_of_helpouts_other: '{{count}} stand-ins',
  },
  home: 'Home',
  home_game: 'Home game',
  home_games: 'Home games',
  hygiene_concept: 'Hygiene concept',
  iban: 'IBAN',
  image_upload_in_table_hint:
    'Image can be uploaded directly in the table after saving.',
  import_users: 'Import users',
  important_information: 'Important information',
  in_min: 'in min',
  interfaces: 'Interfaces',
  inventory: {
    singular: 'Inventory',
    plural: 'Inventory',
    add: 'Add Inventory',
    edit: 'Edit Inventory',
    delete: 'Delete Inventory',
    categories: {
      singular: 'Category',
      plural: 'Categories',
      add: 'Add Category',
      edit: 'Edit Category',
      rename: 'Rename Category',
      show: 'Show {{name}}',
      article_list: {
        not_found: 'Category not found.',
        columns: {
          title: 'Title',
          created_by: 'Created by',
          created_at: 'Created at',
        },
      },
      delete: {
        title: 'Delete Category',
        description:
          "When you delete a category, all items in this category will be moved to the 'Uncategorized' category. Existing subcategories will move up one level in the hierarchy. Are you sure you want to delete the category?",
      },
      navigation: {
        show_inventory: {
          title: 'Show Inventory',
          description: {
            default: 'Show all {{number}} items in the {{name}} category',
            uncategorized: 'Show all uncategorized items',
          },
        },
        subtitle:
          '{{numberOfSubcategories}} subcategories | {{numberOfInventories}} inventory items',
      },
      parentCategory: 'Parent Category',
      uncategorized: 'Uncategorized',
    },
    details: {
      category: 'Category',
      description: 'Description',
      name: 'Name',
      possessor: 'Possessor',
      title: 'Inventory Details',
      status: 'Status',
      share_link: 'Transfer Link',
    },
    not_found: 'Inventory not found',
    pool: {
      title: 'Club Storage',
    },
    possessor: {
      title: 'Possessor',
      you_info: 'You have been the possessor of this inventory since {{date}}',
    },
    transfers: {
      actions: {
        new: 'Start Transfer',
      },
      attributes: {
        type: 'Type',
        from_user: 'From',
        to_user: 'To',
        comment: 'Comment',
        requested_at: 'Requested at',
        transferred_at: 'Transferred at',
        due_date: 'Due date',
      },
      delete: {
        title: 'Delete Transfer',
        description:
          'Are you sure you want to delete this transfer? This action cannot be undone.',
      },
      receive: {
        description:
          'Please confirm that you have received the inventory and want to complete the transfer.',
        confirm: {
          title: 'Confirm Receipt',
          description:
            'Have you received the inventory and want to complete the transfer?',
          success: 'You are now the possessor of the inventory.',
        },
      },
      return: {
        admin_request: {
          title: 'Request Return',
          description:
            'You can request the return of the inventory. The current possessor will be notified and can confirm the return.',
          success:
            'The return has been successfully requested, and the possessor has been notified.',
        },
        confirm: {
          title: 'Confirm Return',
          description:
            'Have you received the inventory back and want to confirm the return?',
          success:
            'The return has been successfully confirmed. The inventory is now back in the club storage.',
        },
      },
      share: {
        create: {
          title: 'Create Transfer Link',
          description:
            'Create a link to transfer the inventory to another user.',
        },
        copy: {
          success: 'The link has been copied to the clipboard.',
        },
        receive: {
          title: 'Accept Inventory',
          description:
            'Do you want to accept the item {{name}} from {{from}}? This transfer will be irrevocably confirmed.',
          confirm: {
            button: 'Accept',
            description:
              'You have accepted the inventory {{name}} from {{from}}. You can now find the item in your inventory list.',
          },
        },
        show_link: 'Show Link',
      },
      status: {
        pending: 'Pending Transfer',
        transferred: 'In Possession',
      },
      title: 'Transfer',
      types: {
        transfer: 'Transfer',
        pass: 'Pass',
        return: 'Return',
      },
      history: 'Transfer History',
    },
  },
  invite_users: 'Invite users',
  invite_users_link: 'Generate invitation link',
  issues: {
    title: 'Conflicts',
    add: 'Add conflict',
    edit: 'Edit conflict',
    delete: 'Delete conflict',
    details: 'Conflict details',
    acknowledged: {
      yes: 'Acknowledged',
      no: 'Open',
    },
    actions: {
      acknowledge: 'Mark as acknowledged',
      hide: 'Hide',
      unhide: 'Unhide',
    },
    blocking: {
      yes: 'Blocking',
      no: 'Non-blocking',
    },
    court_vision: {
      title: 'Court Vision (Beta)',
      beta: {
        title: 'Court Vision is currently in beta',
        description:
          'Court Vision is your new tool for detecting and resolving conflicts, missing assignments, and other issues within your club!',
        lines: {
          1: 'The displayed results are currently calculated live, so loading may take a little longer. Please be patient.',
          2: 'In the future, these calculations will run automatically every night in the background, giving you an up-to-date overview of conflicts and other issues in your club every day.',
          3: 'The following checks are currently performed: user conflicts of all kinds and pending game scheduling. More checks will be added gradually in the future.',
          4: 'Please send your feedback to mblum@backcourt-software.de. Thank you for your support!',
        },
        show_more: {
          more: 'Show more',
          less: 'Show less',
        },
      },
      no_issues: 'Coach T found no issues. Everything looks good!',
      load_error: 'The issues could not be loaded.',
      retry: 'Try again',
      hidden_filter_unavailable:
        'Hidden issues cannot currently be loaded separately.',
      filters: {
        open: 'Open',
        hidden: 'Hidden',
      },
      pagination: {
        load_more: {
          loading: 'Loading...',
          idle: 'Show more',
        },
      },
      reload_button: {
        idle: 'Analyze the next 2 weeks',
        loading: 'Analyzing data...',
      },
      sections: {
        personal: 'For me',
        club: 'Club',
      },
    },
    hidden: {
      yes: 'Hidden',
      no: 'Visible',
    },
    severity: {
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
    },
    status: {
      text: 'Status: {{status}}',
      types: {
        open: 'Open',
        closed: 'Closed',
      },
    },
    types: {
      basketball_event_gym_closed: 'Gym closed',
      basketball_game_tbd: 'Game scheduling pending',
      person_single_event_conflict: 'Role conflict',
      person_multi_event_conflict: 'Schedule conflict',
      unknown: 'Unknown conflict',
    },
  },
  in_progress: 'In progress',
  is_public: 'Is public',
  incomplete: 'Incomplete',
  jersey_number: 'Jersey number',
  jerseys: 'Jerseys',
  judge_team: 'Judges',
  judges: {
    auto_assignment: {
      title: 'Automatic assignment',
      title_with_number: 'Automatic assignment ({{number}} persons)',
      question_number: 'How many people are needed per game?',
    },
    singular: 'Judges',
    team: 'Judge team',
    paper: 'Judge person 1',
    paper_asst: 'Judge person 4',
    time: 'Judge person 2',
    '24sec': 'Judge person 3',
    suggestions: {
      '0': 'Game in the same gym that day',
      '1': 'No game that day',
      '2': 'Home game in another gym',
      '3': 'Away game on this day',
      '4': 'Plays at the same time',
      '5': 'Involved in this game',
    },
  },
  keys: {
    singular: 'Key',
    plural: 'Keys',
    add: 'Add key',
    edit: 'Edit key',
    delete: 'Delete key',
  },
  knowledge_base: {
    title: 'Knowledge Base',
    articles: {
      singular: 'Article',
      plural: 'Articles',
      add: 'Add Article',
      edit: 'Edit Article',
      form: {
        fields: {
          content: 'Content',
        },
      },
      views_one: '{{count}} view',
      views_other: '{{count}} views',
      detail_page: {
        attachments: {
          title: 'Attachments',
          upload: {
            title: 'Upload Attachment',
            description:
              'Drag and drop a file here or click to upload a file. The file size should not exceed 2 MB. Allowed file types: {{types}}',
          },
          delete: {
            description:
              'Are you sure you want to delete this attachment? The file will be permanently deleted.',
          },
        },
        loading: 'Loading...',
        loading_image: 'Loading Image...',
        created_by: 'Created by {{name}} on {{date}} at {{time}}',
        not_found: 'The article was not found.',
      },
      errors: {
        no_data: {
          title: 'No articles found',
          description: 'No articles found!',
        },
      },
      most_read: 'Most Read Articles',
      empty: 'No articles found',
      latest: 'Latest Articles',
      switch_category: {
        title: 'Switch Category',
        description: 'Where would you like to move the selected articles?',
        select_category: 'Select category',
      },
    },
    categories: {
      singular: 'Category',
      plural: 'Categories',
      add: 'Add Category',
      rename: 'Rename Category',
      show: 'Show {{name}}',
      article_list: {
        not_found: 'Category not found.',
        columns: {
          title: 'Title',
          created_by: 'Created by',
          created_at: 'Created at',
        },
      },
      delete: {
        title: 'Delete Category',
        description:
          'If you delete a category, all articles in that category will be moved to the "Uncategorized" category. Existing subcategories will move up one level in the hierarchy. Are you sure you want to delete the category?',
      },
      uncategorized: 'Uncategorized',
    },
    menu: 'Menu',
    search: {
      title: 'Search',
      question: 'What are you looking for?',
      description: 'Enter a search term or browse the categories',
      placeholder: 'Search...',
      results: {
        title: 'Search results for "{{term}}"',
        more_relevant_results: 'More relevant results',
        no_results: 'No results found for the search term "{{searchText}}".',
      },
    },
    tags: {
      singular: 'Tag',
      plural: 'Tags',
      add: 'Add Tag',
    },
  },
  lastname: 'Lastname',
  last_synced_at: 'Last synced at',
  last_updated: 'Last updated',
  later: 'Later',
  leagues: {
    assistant: {
      check: {
        info: '{{number}} games found. Please check if everything is correct before you hit the Save button',
        title: 'Check',
      },
      select_country: {
        title: 'Select country',
        question: 'In which country is the league located?',
        germany: 'Germany',
        switzerland: 'Switzerland (coming soon)',
      },
      select_league: {
        age: 'Age group',
        area: 'Area',
        association: 'Association',
        association_leagues: 'Leagues on association level',
        division: 'Division',
        enter_league_id: 'Enter league id...',
        league: 'League',
        league_id_info:
          'You can find the league ID in the URL of the league on the basketball-bund.net page. Example: https://www.basketball-bund.net/index.jsp?Action=102&liga_id=37239. The league ID is the number after "liga_id=".',
        sex: 'Sex',
        title: 'Select league',
        type: 'Type of league',
      },
      select_teams: {
        club_team: 'Club team',
        league_team: 'League team',
        title: 'Select Teams',
      },
      settings: {
        title: 'Settings',
        own_referees:
          'Does the club has to organize the referees in this league itself? (Referees are not organized by the association)',
      },
    },
    connect: 'Connect league',
    sync: {
      title: 'Synchronize league',
      question:
        'Do you want to synchronize the league manually? Depending on the league, this process can take a few minutes. In addition, the data is cached for 10 minutes. During this time, further synchronizations are ignored. You can see in the table when the league was last synchronized.',
      success:
        'The synchronization was successfully added to the queue. Please wait a moment.',
    },
    no_data: {
      title: 'No Leagues Found',
      description: 'No leagues assigned to you were found.',
    },
    edit: 'Edit league',
    delete: 'Delete league',
    plural: 'Leagues',
    singular: 'League',
  },
  legend: 'Legend',
  limit: 'Limit',
  linked_accounts: 'Linked accounts',
  linked_accounts_info: 'The user gets access to the users selected here.',
  list: 'List',
  loading: 'Loading...',
  location: 'Location',
  login: 'Login',
  login_now: 'Login now',
  logout: 'Logout',
  maintenance_mode: {
    title: 'Maintenance mode',
    message:
      'We are currently cleaning the gym floor and exchanging the nets. Come back later!',
    check_status: 'Check status',
    check_status_in: 'Check status (in {{number}} seconds)',
  },
  manage_notifications: 'Manage notifications',
  manufacturer: 'Manufacturer',
  mark_as_read: 'Mark as read',
  max_num_of_users: 'Max. number of users',
  max_spectators: 'Max. spectators',
  meet_at: 'Meet at',
  meet_at_location: 'Meeting point',
  members: 'Members',
  messages: {
    singular: 'Message',
    plural: 'Messages',
    create: 'Create message',
    edit: 'Edit message',
    delete: 'Delete message',
  },
  min_num_of_users: 'Min. number of users',
  minutes: {
    long: 'Minutes',
    short: 'min',
  },
  more: 'More',
  more_menu: {
    administration: {
      events: {
        description: 'Plan events for your club',
      },
      inventory: {
        description: 'Manage your club’s inventory and assign individual items',
      },
      messages: {
        description: 'Send messages to groups or members of your club',
      },
      season: {
        description: 'Keep track of your club’s matchdays',
      },
      tasks: {
        description: 'Manage tasks for your club and assign them',
      },
      teams: {
        description: 'Get an overview of your club’s teams',
      },
      users: {
        description: 'Your club’s member list',
      },
    },
    my_club: {
      cars_reservations: {
        description:
          'See at a glance which vehicles are being used when and who is currently on the road',
      },
      gym_closures: {
        description: 'See when the gyms are closed',
      },
      knowledge_base: {
        description: 'Looking for information? Find it here!',
      },
      leagues: {
        description: 'Check the current standings in your club’s leagues',
      },
      partners: {
        description:
          'Discover exclusive benefits, promotions, and general information from your club’s partners',
      },
      press_center: {
        description: 'Take a look at your club’s game reports',
      },
      practice_times: {
        description: 'An overview of your club’s practice times',
      },
      schedule: {
        description: 'All your club’s games at a glance',
      },
      teams: {
        description: 'An overview of your club’s teams',
      },
    },
    my_team: {
      events: {
        description: 'Plan and manage your team’s events',
      },
      messages: {
        description: 'Send messages to your team',
      },
      players: {
        description: 'Manage your team’s players',
      },
      settings: {
        description: 'Manage your team’s settings',
      },
      tasks: {
        description: 'Create team tasks or assign club tasks',
      },
    },
  },
  model: 'Model',
  multiple_users: 'Multiple users',
  my_assignments: 'My assignments',
  my_club: 'My club',
  my_events: 'My events',
  my_games: 'My Games',
  my_team: 'My team',
  my_upcoming_events: 'My upcoming events',
  name: 'Name',
  nationality: 'Nationality',
  new_message: 'New message',
  never: 'Never',
  next: 'Next',
  no: 'No',
  no_team: 'No team',
  nominees: {
    all_players_nominated: 'All players nominated',
    info_text:
      'Here you can nominate players for the selected event. If you do not nominate any players, all players (including those who are added to the team later) will be automatically nominated.',
    nominate_players: 'Nominate players',
    nominated: 'Nominated',
    nominated_players: 'Nominated players',
    not_nominated: 'Not nominated',
    number_of_nominated_players_one: 'One player nominated',
    number_of_nominated_players_other: '{{count}} players nominated',
    user_not_nominated:
      'The selected player has not been nominated for this event.',
  },
  note: 'Note',
  notifications: {
    singular: 'Notification',
    plural: 'Notifications',
    new: 'New notification',
    new_categories: {
      title: 'New notification categories',
      message:
        "We've updated our notification categories! Please check your settings to ensure that all desired notifications are enabled. Please click 'Save' even if you haven't made any changes.",
      action: 'Open settings',
    },
    /** Types */
    admin: 'Administrator',
    all: 'All',
    assignments: 'Assignments',
    basketball: 'Basketball',
    birthdays: 'Birthdays',
    coaches: 'Coaches',
    comments: 'Comments',
    events: 'Events',
    event_reply: 'Event reply',
    game_sync: 'League synchronization (game list)',
    games: 'Games',
    general: 'General',
    inventories: 'Inventory',
    jerseys: 'Jerseys',
    judges: 'Judges',
    messages: 'Messages',
    players: 'Players',
    practices: 'Practices',
    prospects: 'Prospects',
    referee: 'Referee',
    referees: 'Referees',
    reminders: 'Reminders',
    switch_requests: 'Switch requests',
    switches: 'Switch requests',
    tasks: 'Tasks',
    team: 'Team',
    team_assignment: 'Team assignment',
    team_assigned: 'Team assignments',
    team_tasks: 'Tasks',
    user_registration: 'User registration',
    users: 'Users',
    /** Questions */
    questions: {
      delete_all: 'Delete all notifications?',
      mark_all: 'Mark all notifications as read?',
    },
  },
  number: 'Number',
  number_of_seats: 'Number of seats',
  ok: 'Ok',
  operations_center: {
    title: 'Operations Center',
    open_task: {
      singular: 'Open task',
      plural: 'Open tasks',
      messages: {
        no_team_assigned: 'The task {{task}} is not assigned to a team.',
        not_fully_assigned:
          '{{number}} more people need to be assigned to the task {{task}}.',
      },
    },
    conflict: {
      singular: 'Conflict',
      plural: 'Conflicts',
      messages: {
        overlapping: 'The person {{name}} has scheduling conflicts!',
      },
      roles: {
        coach: 'Coach',
        player: 'Player',
        referee: 'Referee',
      },
    },
  },
  opponent: 'Opponent',
  owners: {
    singular: 'Owner',
    plural: 'Owners',
    add: 'Add owner',
    edit: 'Edit owner',
    delete: 'Delete owner',
  },
  own_column_arrangements: 'Own column arrangements',
  own_guest_team: 'Own guest team',
  own_home_team: 'Own home team',
  own_referee1: 'Referee 1',
  own_referee2: 'Referee 2',
  own_referees: 'Own referees',
  own_reply: 'Own reply',
  parent_accounts: 'Parent accounts',
  parking: 'Parking',
  participants: {
    singular: 'Participant',
    plural: 'Participants',
  },
  partners: {
    singular: 'Partner',
    plural: 'Partners',
    add: 'Add partner',
    edit: 'Edit partner',
    delete: 'Delete partner',
    form: {
      fields: {
        address: 'Address',
        category: 'Category',
        name: 'Name',
        description: 'Description',
        url: 'Website',
        street: 'Street',
        zip_code: 'Postal code',
        city: 'City',
        image: 'Logo',
        sort_order: 'Sort order',
      },
      info: {
        category: "Category addition to partner name (e.g. 'Main sponsor')",
        sort_order:
          'Higher numbers = display first. No number = default sorting by name.',
      },
    },
    sections: {
      singular: 'Section',
      plural: 'Sections',
      add: 'Add section',
      edit: 'Edit section',
      delete: 'Delete section',
      valid_until: 'Valid until',
      valid_from: 'From',
      expired: 'expired',
      form: {
        fields: {
          title: 'Title',
          body: 'Description',
          sort_order: 'Sort order',
          active: 'Active',
          starts_at: 'Valid from',
          ends_at: 'Valid until',
          type: {
            title: 'Type',
            enum: {
              text: 'Text',
              coupon: 'Coupon',
              news: 'News',
            },
          },
          image: 'Image',
        },
      },
    },
  },
  past_games: {
    show: 'Show past games',
    hide: 'Hide past games',
  },
  passive: 'Passive',
  passive_member: 'Passive member',
  password: 'Password',
  password_confirmation: 'Confirm password',
  person: 'Person',
  phone: 'Phone',
  pending: 'Pending',
  player: 'Player',
  players: 'Players',
  possible_events: 'Possible events',
  practice: 'Practice',
  practice_time: {
    add: 'Add practice time',
    edit: 'Edit practice time',
    split_gym: {
      title: 'Split gym',
      description:
        'The gym is divided into several parts. The teams train simultaneously in different parts of the gym.',
    },
  },
  practice_times: 'Practice times',
  practices: {
    singular: 'Practice',
    singular_short: 'Practice',
    plural: 'Practices',
    add: 'Add Practice',
    add_plural: 'Add Practices',
    add_multi_via_web:
      'Multiple practice times and practice series can be added via the web version.',
    canceled: 'This practice was canceled.',
    edit: 'Edit Practice',
    edit_plural: 'Edit practices',
    delete: 'Delete Practice',
    administration: {
      title: 'Practice Management',
      practice_times: {
        title: 'Practice Times',
        calendar: {
          title: 'Weekly View',
        },
        new_feature_info:
          'Practice times are now managed in the Practice Management section. You can find this feature under Season > Practice Management.',
        iframe: {
          feature_info:
            'You can also embed the overview of practice times on your homepage. Copy the iFrame code and add it to your homepage.',
          title: 'iFrame',
          description: 'Insert this iFrame code on your homepage.',
          link: {
            title: 'Link',
          },
        },
        schedules: {
          title: 'Practice Schedules',
          add: 'Add Practice Schedule',
          duplicate: 'Duplicate Practice Schedule',
          edit: 'Edit Practice Schedule',
          active: {
            description:
              'Should this schedule be a draft for now? The schedule will only affect the generation of practice sessions after it has been activated.',
          },
          active_from_till: {
            from_till: 'Active from {{from}} until {{till}}',
            from: 'Active from {{from}}',
            till: 'Active until {{till}}',
          },
          current: {
            title: 'Current Practice Schedule: {{name}}',
          },
          mark_as_default: {
            title: 'Mark as Default',
            description:
              'The default schedule will automatically be used on days when no specific practice schedule is set.',
          },
          upcoming: {
            more: 'More Upcoming Practice Schedules',
            title: 'Upcoming Practice Schedule: {{name}}',
          },
        },
      },
      tour: {
        one: {
          title: 'New Practice Management',
          description:
            'Welcome to the new practice management system. You can now create multiple practice plans that automatically apply based on the defined time period. Additionally, you can create new practice plans or duplicate existing ones.',
        },
        two: {
          title: 'Overview and Management of Practice Plans',
          description:
            'In the overview, you can see which practice plan applies to which time period.',
        },
        three: {
          title: 'Management of Practice Times',
          description:
            'Here, you can manage the practice times of your teams. You can create new practice times as well as edit or delete existing ones.',
        },
        four: {
          title: 'Switching Between Practice Plans',
          description:
            'You can switch between different practice plans using the dropdown menu.',
        },
        five: {
          title: 'Generating Practice Sessions',
          description:
            "After creating or adjusting your plan, you can automatically generate or update all practice sessions using this button. Note that under 'Administration > Teams,' a 'Synchronize Until' date can be set for each team. Practice sessions will be synchronized up to this date.",
        },
      },
    },
    sync: {
      title: 'Synchronize Practice Sessions',
      until: 'Synchronize Practice Sessions Until',
      admin: {
        info: 'Here you can control the automatic synchronization of practice sessions. The practice sessions will be automatically synchronized until the selected date. If the newly selected date is earlier than the date for a chosen team, all previously synchronized/generated practice sessions that occur after the selected date will be deleted. The synchronization can be performed in the practice management.',
      },
      status: {
        until:
          'Practice sessions are automatically synchronized until {{date}}.',
        no_sync:
          'Practice sessions are currently not being automatically synchronized.',
      },
      icon: {
        tooltip: 'Automatically generated practice session',
      },
      info: 'Do you want to synchronize the practice sessions of your club? All practice sessions will be synchronized based on the practice schedules for each team until the set date (Administration > Teams). Manually created practice sessions will remain unchanged.',
    },
    details: 'Practice details',
    link: 'Link practices',
    link_info:
      'With this feature, all practices are automatically added up to the selected date. Advantage: If the administrator changes the practice location, the weekday or the time, all events are automatically updated. Note: The administrator must have stored the practice times in order that this feature will work. Attention: Already deleted practices are added again if you perform this action! ',
    errors: {
      select_active_coach_team: 'The active team must be selected',
    },
    other_practices: {
      same_day: {
        title: 'Day view',
        description:
          'Discover the other practice sessions of other teams on this day in this gym.',
      },
    },
  },
  press_center: {
    title: 'Press Center',
    settings: {
      title: 'Press Center',
      feature_info:
        'Embed the press center on your homepage and inform the press and other interested parties about your club’s latest game reports.',
      link: {
        title: 'Link',
      },
      iframe: {
        title: 'iFrame',
        description: 'Insert this iFrame code on your homepage.',
      },
    },
    details: {
      created_by: 'Created by {{name}} on {{date}}',
    },
  },
  prev: 'Previous',
  preview: 'Preview',
  print: 'Print',
  privacy: 'Privacy',
  private_cars: 'Private cars',
  profile: 'Profile',
  prospects: {
    singular: 'Prospect',
    plural: 'Prospects',
    add: 'Add prospect',
    edit: 'Edit prospect',
    delete: 'Delete prospect',
    experience: {
      title: 'Experience',
      none: 'None',
      low: 'Beginner',
      medium: 'Intermediate',
      high: 'Advanced',
    },
    info: {
      delete:
        'Are you sure you want to delete this prospect? If the status is "Pending", an email with a rejection will be sent to the prospect.',
      teams:
        'Here you can assign the prospect to one or more teams. Coaches of the selected teams will be automatically notified and can accept, waitlist, or decline the prospect.',
      text: "Here you will find all the prospects who have contacted your club through the contact form on your website. You can accept, waitlist, or reject the prospects. When you perform any of these actions, the prospect will be automatically notified by email. In case of acceptance, the email will contain information about your team's training times. Additionally, you can add a personal message to the prospect.",
      reply: {
        approved:
          'Approve: The prospect will receive an acceptance email with the training times of the selected team.',
        declined:
          'Decline: The prospect will receive a rejection email with the information that they can reapply next season.',
        waitlist:
          'Waitlist: The prospect will receive an email stating that all teams are currently full, but they are on the waitlist. Once a spot becomes available, they can reapply with "Approve".',
        description:
          "Here you can reply to the inquiry. If you add a message, it will be attached to the prospect's standard email. Note: Even if you have already replied, a new email with the updated response will still be sent. The default email contains the following content:",
      },
    },
    message: 'Message',
    replies: {
      singular: 'Reply',
      approve: 'Approve',
      decline: 'Decline',
      waitlist: 'Waitlist',
      previous: {
        title: 'Previous replies',
        text: 'Reply from {{date}}',
        replied_by: 'Reply by {{name}}',
      },
      reply: 'Reply',
    },
    sign: {
      title: 'Register prospect',
      description:
        'Would you like to register the prospect as a member in Backcourt? The prospect will be automatically created as a member and will receive an email with the login credentials. Additionally, they will be automatically added to the selected teams.',
    },
    settings: {
      title: 'Prospects',
      feature_info:
        'The prospects feature allows you to manage prospects and, if necessary, register them as members. All you have to do is integrate the contact form via link or iFrame on your website. The prospects will then be automatically created in Backcourt and you can manage them here. If you have specified the gender and age group for your teams, the prospects will be automatically assigned to the appropriate team (provided there is only one match). Admins (and possibly coaches) will automatically receive a notification when someone submits a form via the contact form. The prospects will be automatically notified by email when you put them on the waitlist, decline, or accept them. If accepted, the email will automatically include the training times for your team.',
      iframe: {
        title: 'iFrame',
        description: 'Add this iFrame code to your website.',
      },
      link: {
        title: 'Link',
      },
    },
    status: {
      title: 'Status',
      pending: 'Pending',
      approved: 'Approved',
      declined: 'Declined',
      waitlist: 'Waitlist',
      signed: 'Signed',
    },
  },
  push: 'Push',
  reason: 'Reason',
  recipients: 'Recipients',
  referees: {
    singular: 'Referee',
    plural: 'Referees',
    referee_1: 'Referee 1',
    referee_2: 'Referee 2',
    referee_bill: 'Referee Bill',
    assign_me: {
      title: 'Assign me',
      description:
        'Do you want to register yourself as a referee? If so, please consider that this is binding. However, you can make a change request if you want to deregister later. Your entry remains until another referee takes over your assignment.',
    },
  },
  refresh: 'Refresh',
  refresh_page: 'Refresh page',
  registration: {
    title: 'Registration',
    subtitle:
      'Hello, the club {{name}} would like you to join the software Backcourt. As a member you will have access to all your schedules!',
    subtitle_team:
      'You will be added to the team {{name}} directly after registration.',
    link_accounts_info:
      "Please note: E-mail address and password serve as login! Therefore, each mail address can be used only once. Parents can (if the child/children do not yet have their own e-mail addresses) enter their data and request accounts for the children without e-mail addresses from the club administration. The children's accounts will then be linked to the parents' account by the club administration.",
  },
  registration_status: 'Registration status',
  replies: 'Replies',
  represented_by: 'Legal guardian',
  request_password: 'Request password',
  reset: 'Reset',
  reset_password: 'Reset password',
  result_reporting: 'Result reporting',
  roles: {
    role: 'Roles',
    roles: 'Roles',
    admin: 'Administrator',
    bb_admin: 'Administrator',
    bb_coach: 'Coach',
    bb_referee: 'Referee',
    bb_user: 'User',
    vehicle_admin: 'Vehicle administrator',
  },
  row: 'Row',
  save: 'Save',
  save_column_selection: 'Save column selection',
  schedule: 'Schedule',
  scheduled: 'Scheduled',
  scrimmage_game: 'Scrimmage game',
  scrimmage_games: 'Scrimmage games',
  search: 'Search',
  search_player: 'Search player',
  season: 'Season',
  season_planer: {
    title: 'Season Planer',
    gym_closures: {
      title: 'Gyms closed!',
      description: 'The following gyms are closed on this day: {{gyms}}',
    },
  },
  seats: 'Seats',
  seats_available: 'Seats available',
  select: 'Select',
  select_all: 'Select all',
  select_columns: 'Select columns',
  select_date: 'Select date',
  select_game: 'Select game',
  select_location: 'Select location',
  select_player: 'Select player',
  select_recipients: 'Select recipients',
  select_team: 'Select team',
  select_user: 'Select user',
  select_users: 'Select users',
  select_widget: 'Select widget',
  selected: 'Selected',
  semicolon: 'Semicolon',
  send: 'Send',
  send_welcome_mail: 'Send welcome mail',
  sender: 'Sender',
  settings: {
    title: 'Settings',
    interfaces: {
      ical: 'iCal calendar',
    },
    user: {
      privacy: {
        display_name_on_team_page: {
          title: 'Show name',
          description: 'Show your name on the team page for other members',
        },
      },
      child_events: {
        title: 'Events of linked accounts',
        description: 'Show events of linked accounts in your own event list',
      },
      avatar: {
        update: 'Update profile picture',
        delete: 'Delete profile picture',
      },
      init_app_screen: {
        title: 'Show events on startup',
        description: 'Show events on startup instead of the "Upcoming" screen.',
      },
    },
  },
  sex: {
    title: 'Sex',
    male: 'Male',
    female: 'Female',
    diverse: 'Diverse',
  },
  show_all: 'Show all',
  shuffle: 'Shuffle',
  smart_assistant: {
    intro: {
      text: 'Solly {{name}}! I am Coach T, your future assistant for club operations. I can help you analyze your club data, for example conflicts among your members! Take a look at the Court Vision feature. Enjoy!',
    },
  },
  sorting: 'Sorting',
  standings: 'Standings',
  statistics: {
    plural: 'Statistics',
    date_range: {
      title: 'Date range',
    },
    games: {
      title: 'Games',
    },
    practices: {
      title: 'Practices',
    },
    tasks: {
      title: 'Tasks',
    },
    users: {
      title: 'Users',
    },
  },
  status: 'Status',
  street: 'Street',
  subject: 'Subject',
  subscriptions: {
    active_subscriptions: 'Active subscriptions',
    billing_portal: 'Billing portal & Cancellation',
    full_features: {
      info: 'You can find an overview of the functionality of the products here:',
      link: 'Product overview',
    },
    change_subscription: {
      checkbox_text: 'I have read and understood the terms and conditions.',
      confirm_button: 'Update subscription',
      downgrade: {
        pending_title: 'Pending subscription downgrade',
        info: 'You can cancel the downgrade until {{date}} using the button below. After cancellation, your current subscription will continue and you can switch to another subscription if necessary.',
        button: 'Cancel downgrade',
        button_tooltip: 'Are you sure?',
      },
      info_with_restrictions:
        'You can cancel your subscription or view invoices at any time via “Billing Portal & Cancellation”. You can switch to another product below this text. An upgrade is possible at any time. A downgrade will be carried out at the end of the current term. In addition, a downgrade is only possible if you have not exceeded the data limits of the respective subscription. Termination is possible at the end of the term, but please note that data that exceeds the free limit may be deleted after termination. If you have any questions, we will be happy to help you.',
      info_without_restrictions:
        'You can cancel your subscription or view invoices at any time via “Billing Portal & Cancellation”. You can switch to another product below this text. An upgrade is possible at any time. A downgrade will be carried out at the end of the current term. In addition, a downgrade is only possible if you have not exceeded the data limits of the respective subscription. Termination is possible at the end of the term, but please note that data that exceeds the free limit may be deleted after termination. If you have any questions, we will be happy to help you.',
      invoice_preview: {
        title: 'Confirm subscription update',
        card_info:
          'The currently stored payment method will be used. If you would like to use a different payment method, please change it in the billing portal before updating.',
        calculation: {
          info: 'Composed of',
          credit: 'Credit from {{product}}',
          charge: 'Charge for {{product}}',
        },
        general_info:
          'Here you can see an overview of how the package change affects your bills.',
        due: {
          afterwards: {
            month: 'What amount is due monthly from {{date}}',
            year: 'What amount is due annually from {{date}}',
          },
          next: {
            today: 'Due today',
            date: 'Due on {{date}}',
          },
        },
        type_info: {
          switch: 'Your switch will take place immediately.',
          switch_immidiate:
            'Your package upgrade will be carried out immediately and you will immediately start enjoying the new features.',
          switch_next_period:
            'Your package downgrade will occur at the end of the current term. Until then, you can still use all the functions of your current package. Please note that after downgrading, you may irrevocably lose data that exceeds the limit of the selected package.',
        },
      },
      too_many: 'Too many {{type}} ({{count}})',
      button_type: {
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        active: 'Active',
        switch: 'Switch',
        switch_immidiate: 'Switch immediately',
        switch_next_period: 'Switch at the end of the current term',
        not_allowed: 'Not allowed',
      },
      success: {
        message: {
          switch_immidiate:
            'Thank you for your trust. Your package has been successfully changed. You can now immediately use all the functions of your subscription! Have fun! 🏀',
          switch_next_period:
            'Your subscription downgrade will be carried out at the end of the current term. Please note that after downgrading, you may irrevocably lose data that exceeds the limit of the selected subscription.',
        },
      },
    },
    includes: 'Includes, among other things',
    no_subscription: {
      info: 'No subscription has been created yet. Please select a subscription below and proceed to checkout using our payment service provider Stripe.',
    },
    price: {
      per_year: '{{amount}} €/year',
      per_month: '{{amount}} €/month',
    },
    subscribe: 'Subscribe',
    title: 'Subscriptions',
    trial: {
      title: 'Trial period',
      info: 'You can enjoy all the functions of the Bundesliga package until {{date}}. After the test phase, the "Freiplatz"-Package will automatically become active. You can upgrade at any time.',
    },
    kreisliga: {
      title: 'Kreisliga',
    },
    regionalliga: {
      title: 'Regionalliga',
    },
    bundesliga: {
      title: 'Bundesliga',
    },
  },
  switch_account: 'Switch account',
  switch_requests: {
    singular: 'Switch request',
    plural: 'Switch requests',
    create_info_text:
      'No switch requests available. You can create a new one via the + button at the top right!',
  },
  switch_team: 'Switch team',
  tab: 'Tab',
  table: {
    pagination: {
      total: '{{from}}-{{to}} von {{total}} items',
    },
  },
  tan: 'TA-number',
  take_over: 'Take over',
  taken_over_by: 'Taken over by {{name}}',
  tasks: {
    assignment: 'Task assignment',
    auto_assignment: {
      title: 'Automatic assignment',
      steps: {
        mode: {
          title: 'Select Type',
          description:
            'Please select whether you would like to automatically assign teams or users.',
          users: 'User',
          basketball_teams: 'Teams',
        },
        events: {
          title: 'Event selection',
          description:
            'Select the appointments for which you want to perform automatic assignment.',
        },
        users: {
          title: 'Define exceptions',
          description:
            'Define exceptions for automatic assignment. The deselected users and teams will not be taken into account for the allocation.',
        },
        options: {
          title: 'More options',
          description: '',
          number_of_assignables: {
            title: 'Number per event',
            description: 'How many users/teams should be assigned per event?',
          },
          consider_prev_assignments: {
            title: 'Older Assignments',
            description:
              'Should older allocations be taken into account? Example: If a user has been assigned more frequently than other users in the past, he or she will no longer be taken into account for the automatic assignment (or will be considered less frequently).',
            no: 'No',
            current_season: 'Current season (01/08 - 31/07)',
            custom: 'Own period',
          },
        },
        preview: {
          title: 'Preview',
          description:
            'Check and change the automatic assignments if necessary.',
        },
      },
    },
    create: 'Create task',
    delete: 'Delete task',
    edit: 'Edit task',
    more: 'More tasks',
    num_of_user_assignments: 'Num. assignments',
    num_of_user_assignments_more:
      'Number of all assignments. In the case of club tasks, this number may be higher than the number of selected users, since other teams and users can also be assigned to this task.',
    own_assignments: {
      allow: 'Allow own assignments',
      title: 'Own assignments',
    },
    past_events: {
      show: 'Show past events',
      hide: 'Hide past events',
    },
    plural: 'Tasks',
    singular: 'Task',
    club: 'Club tasks',
    requires_presence: {
      title: 'Presence required',
      description:
        'If this option is enabled, users must be present for this task. The task will also be considered in the conflict check.',
    },
    single_user_assignment: {
      assign: {
        title: 'Assign task',
        question:
          'Do you really want to take over this task? You can give it up at any time.',
      },
      give_up: {
        title: 'Give up task',
        question:
          'Do you really want to give up this task? You can take it over again at any time.',
      },
    },
    team: 'Team tasks',
    teams_assignments: 'Team assignments',
    users_assignments: 'User assignments',
    questions: {
      delete: 'Do you really want to delete this task?',
      dont_take_over: "Don't you want to take on this task?",
      take_over: 'Do you want to take over this task?',
    },
  },
  tbd: 'TBD',
  this_week: 'This week',
  team: 'Team',
  team_details: 'Team details',
  team_profile: {
    photo: {
      edit: 'Edit team photo',
      delete: 'Delete team photo',
    },
  },
  team_tan: 'Team specific TA number',
  teams: 'Teams',
  termination: {
    singular: 'Termination',
    plural: 'Terminations',
    add: 'Add termination',
    edit: 'Edit termination',
    delete: 'Delete termination',
    pending: 'Pending',
    revoke: 'Revoke termination',
    info: {
      active:
        'Termination scheduled for {{date}}. After the termination date, the user status will automatically be changed to "terminated". The user will be removed from all teams and will no longer be able to use Backcourt. The user can then be deleted manually if required.',
      none: 'There are no terminations for this user. You can schedule a termination using the form below.',
    },
    form: {
      fields: {
        termination_date: 'Termination date',
        reason: 'Reason',
      },
    },
    terminated: 'Terminated',
  },
  time: 'Time',
  till: 'Till',
  title: 'Title',
  today: 'Today',
  tomorrow: 'Tomorrow',
  transfer_players: 'Transfer players',
  tutorials: {
    singular: 'Tutorial',
    plural: 'Tutorials',
    alert: {
      button: 'Show tutorial',
      empty_description:
        'A new tutorial has been added. Check it out now so you can use Backcourt even better!',
    },
    button: {
      next: 'Next',
      done: 'Alright!',
    },
  },
  type: 'Type',
  unknown: 'Unknown',
  upcoming: 'Upcoming',
  upcoming_club_games: 'Upcoming club games',
  upcoming_game: 'Upcoming Game',
  upcoming_league_games: 'Upcoming league games',
  update: {
    title: 'Update',
    title_backcourt: 'Backcourt Update {{version}}',
    message_1_0_0:
      'Welcome to the "new" backcourt! Together with the App Update 1.0.0, Backcourt starts with a completely revised system, which will react to new requirements even faster in the future. Existing function not found? Click on "Backcourt 0.21.1" (old version) below to get to the old Backcourt version. All missing functions will be submitted in the coming weeks. Questions? Look at our help page or contact us!',
    message_1_1_0:
      'The new update 1.1.0 brings some changes. The previously defined tasks (judges, hall responsibility and jerseys for teams) are now obsolete. In its place there is now the "Tasks" function. This feature was previously only available for teams. However, administrators can now create tasks and assign both teams and users. Once teams are assigned to a task, coaches can nominate their players for that task. Existing team tasks will migrated to the new function by August 1st.',
    modal: {
      text: 'Backcourt has been updated to version {{version}}. You can see a list of all changes by clicking "Changelog".',
      button: 'Change log',
    },
  },
  updated_at_time: 'Updated at {{date}}',
  url: 'URL',
  user: 'User',
  user_tasks: {
    singular: 'Task',
    plural: 'Tasks',
    inventory: {
      confirm: {
        title: 'Confirm Inventory Transfer',
        description:
          'Please confirm in your inventory list that you have received the item {{name}}.',
      },
      confirm_return: {
        title: 'Confirm Inventory Return',
        description:
          'Please confirm in the inventory management that {{from}} has returned the item {{name}}.',
      },
      return: {
        title: 'Return Inventory',
        description: {
          with_due_date:
            'Please return the item {{name}} to the inventory manager by {{date}}.',
          without_due_date:
            'Please return the item {{name}} to the inventory manager.',
        },
      },
    },
  },
  version: 'Version',
  welcome_text: 'Welcome text',
  week: 'Week',
  weekday: 'Day of week',
  widgets: 'Widgets',
  yes: 'Yes',
  yesterday: 'Yesterday',
  zipcode: 'Zipcode',
  scouting: {
    free_throws_short: 'FT',
    free_throws_long: 'Free Throw',
    fouls: 'Fouls',
    last_5: 'Last 5',
    load_report: 'Load report',
    loss_long: 'Loss',
    loss_short: 'L',
    losses: 'Losses',
    minus: 'Minus',
    no_data: 'No data available',
    player_stats: 'Player stats',
    plus: 'Plus',
    points_chart: 'Points chart',
    points: 'Points',
    quote: 'Quote',
    team_stats: 'Team stats',
    threes_long: 'Threes',
    threes_short: '3s',
    win_long: 'Win',
    win_short: 'W',
    wins: 'Wins',
  },
  questions: {
    activate_users:
      'Are you sure you want to activate the selected users? The members will automatically receive a welcome email after activation. Selected, already activated members will be ignored.',
    ask_delete_with_date: 'Do you really want to delete this entry ({{date}})?',
    ask_delete_with_type: 'Do you really want to delete this {{type}}?',
    ask_take_over_with_date:
      'Do you really want to take over this event ({{date}})?',
    create_switch_request:
      'For which event would you like to create a request?',
    delete: 'Delete? Warning: This action cannot be undone!',
    delete_game:
      'Are you sure you want to delete this game? All associated data will also be removed',
    delete_player: 'Do you really want to remove {{player}} from this team?',
    delete_players:
      'Do you really want to remove the selected players from this team?',
    delete_request: 'Do you really want to delete this request?',
    delete_users_one:
      'Do you really want to delete the selected user? This action cannot be undone. All data associated with the user will also be deleted.',
    delete_users_other:
      'Do you really want to delete the {{count}} selected users? This action cannot be undone. All data associated with the users will also be deleted.',
    forgot_password: 'Forgot password?',
    invite_users:
      'Here you can invite members to Backcourt. We will send a link to every valid email address with which the invited persons can register themselves. Please enter only one email address per line.',
    invite_users_link:
      'Generate invitation link? The link is valid for 48 hours. You can generate a new link every 24 hours.',
    send_welcome_mail:
      'Would you like to send a welcome email to the selected members? The members will receive a link to set a password for Backcourt. Members who have already set a password will be ignored.',
    switch_account:
      'Do you really want to switch users and continue as {{firstname}} {{lastname}}?',
  },
  errors: {
    assign_users: 'Users could not be assigned.',
    avatar_upload: {
      too_large: 'Max. 2MB allowed',
      wrong_format: 'False format',
    },
    basketball_coaches: {
      fetch: 'Coaches could not be loaded.',
    },
    basketball_leagues: {
      sync: {
        too_many_requests:
          'A synchronization is only possible every 10 minutes. Please try again later.',
      },
    },
    basketball_users: {
      fetch: 'Users could not be loaded.',
      create: 'User could not be created.',
      update: 'User could not be updated.',
      delete: 'User could not be deleted.',
    },
    basketball_teams_fetch: 'Teams could not be loaded.',
    child_users_fetch: 'Error while loading your other accounts.',
    create_comment: 'The comment could not be sent.',
    custom_user_attributes: {
      fetch: 'Club fields could not be loaded.',
    },
    download: 'The requested file could not be created.',
    generic: {
      create: 'Entry could not be created.',
      update: 'Entry could not be updated.',
      delete: 'Entry could not be deleted.',
    },
    gyms: {
      fetch: 'Gyms could not be loaded.',
    },
    inventory: {
      transfers: {
        share_link_not_found: 'The shared link could not be found.',
      },
    },
    mail: 'The email could not be sent. Try again later or contact support.',
    load_more_comments: 'Could not load more comments.',
    login: 'Wrong email address and / or wrong password. Please try it again.',
    logout: 'Hoopala, something went wrong when you log out. Please try again.',
    permissions: {
      first: 'For this feature you need at least the "Kreisliga" package',
      second: 'For this feature you need at least the "Regionalliga" package',
      third: 'For this feature you need at least the "Bundesliga" package',
      users:
        'You have already reached the maximum number of users for your plan.',
      basketball_teams:
        'You have already reached the maximum number of teams for your plan.',
      tasks:
        'You have already reached the maximum number of tasks for your plan.',
      practice_time_schedules:
        'You have already reached the maximum number of practice time schedules for your plan.',
    },
    practice_time: {
      save: 'Practice time could not be saved.',
      delete: 'Practice time could not be deleted.',
    },
    register_user:
      'Registration was not successful. Try it again or contact support.',
    reset_password:
      'The password could not be reset. Please try again later or contact support.',
    single_game_fetch: 'Game could not be loaded.',
    single_practice_fetch: 'Practice could not be loaded.',
    stripe: {
      fetch_products: 'Products could not be loaded.',
    },
    switch_requests: {
      fetch: 'Request could not be loaded.',
      create: 'Request could not be created.',
      delete: 'Request could not be deleted.',
      fetch_possible_games: 'Your possible switch events could not be loaded.',
      fetch_possible_tasks: 'Your tasks could not be loaded.',
      take_over: 'Task could not be taken.',
    },
    tasks: {
      assignment:
        'Task could not be assigned. Please consider the number of users required for this task.',
      min_number_of_users: 'Min number of users ({{min}}) not reached.',
      max_number_of_users: 'Max number of users exceeded.',
    },
    token_invalid:
      'The link is not valid or the email address you entered is incorrect. Please check your entry or request a new link.',
    token_invalid_registration:
      'There is a problem with the link! The link is no longer valid or your club has reached the maximum number of users. Get in touch with your club. They can check the limit and, if necessary, send you a new link.',
    undefined: 'Undefined error',
    update_game: 'The game could not be updated.',
    update_judge_user: {
      already_exists: 'The selected user is already assigned to this game.',
    },
    update_reply: 'Answer could not be changed.',
    userdata: 'User data could not be loaded.',
    users: {
      activate: 'Users could not be activated',
      delete_multi: 'Users could not be deleted',
      update_children: 'Linked accounts could not be saved',
      update_user_rights: 'Rights could not be saved',
      no_selection: 'No users selected',
      has_inventory:
        'The user {{name}} has the following inventory items assigned: {{inventoryList}}. Make sure that the inventory is returned. When the user is deleted, the inventory will be assigned back to the club inventory.',
    },
    users_import: 'Could not import members.',
  },
  form_errors: {
    date: 'Please enter a valid date',
    date_range: 'Please enter a valid date range',
    email: 'Please enter a correct email address',
    gym: 'Please select a gym',
    location: 'Please enter a location',
    max_chars: 'The maximum number of characters is {{max}}',
    name: 'Please enter name',
    no_own_team: 'Please select a team where you are active as a coach',
    number: 'Please enter an integer',
    number_min: 'The number cannot be less than {{min}}',
    number_max: 'The number cannot be greater than {{max}}',
    password: 'Please enter a password',
    password_confirm: 'The two passwords that you entered do not match',
    password_length: 'Please enter at least 8 characters',
    privacy: 'Please accept the privacy policy',
    recipient: 'Please enter a recipient',
    same_team: 'Please choose different teams',
    select_value: 'Please select a option',
    sex: 'Please enter a sex',
    text: 'Please enter a text',
    time: 'Please enter a valid time',
    title: 'Please enter a title',
    user_consent: 'A declaration of consent must be available',
    value: 'Please enter a value',
    weekday: 'Please select a day of the week',
  },
  greetings: {
    good_day: 'Hello',
    good_morning: 'Good morning',
    good_evening: 'Good evening',
    hello: 'Hello',
  },
  information_texts: {
    create_request: 'You can create a new requests by tapping on the + Button',
    check_inbox: 'Please check your inbox (including your spam folder)',
    club_information: 'Here is some information from your club',
    coming_soon_in_app_go_to_web:
      'This function is currently only available in the web version ',
    edit_practices:
      'Empty fields are ignored and not adopted at the selected units.',
    empty_view: 'Nothing to show here...',
    forgot_password:
      'Forgot Password? No problem, just enter your email address and we will send you a new one!',
    found_mail_addresses: 'Found {{number}} valid e-mail addresses',
    input_tan:
      'Please enter the last 3 digits of the TA number without leading zeros. Leading zeros will be filled in automatically.',
    is_public:
      'The task is visible to everyone in the event details. Users can sign up for this task.',
    jerseys: 'You have to wash the jerseys after the game!',
    linked_accounts:
      'Here you can enter linked accounts for the user. This is makes sense, if the user does not have an own e-mail address or other users should manage the account. In this column, e-mail addresses have to be separated by a Comma and must agree with an existing account or an account, that will be imported too.',
    login_error: 'Username/password wrong. Please try again.',
    max_participants: 'Maximum number of participants reached',
    no_changes: 'No changes have been made yet',
    no_data: 'No data available',
    no_games: 'No games available',
    no_notification_settings:
      'You have not activated any notifications yet! Adjust your settings to stay up-to-date!',
    no_requests: 'No requests available',
    no_standings: 'No standings available',
    no_squad: 'No team information available',
    no_switch_possible: 'Creating or taking over requests is not possible',
    no_upcoming_events: 'There are no events in the upcoming days',
    no_user_events: 'Your calendar is empty – the court is waiting for you!',
    notification_settings:
      "Make your changes. If you don't want to be notified for anything, just tap Save.",
    permissions: {
      camera_roll: 'We need camera roll permissions to make this work!',
      file_system: 'We need file system permissions to make this work!',
    },
    read_privacy: 'Yes, I have read the privacy FAQs',
    registration_successful:
      'Registration successful! From now on you have your schedule always at a glance! Attention: Your schedule will be empty until your club has assigned you to one or more teams. In the meantime you can adjust your notification settings.',
    reply_reason:
      "Your coach wants to know, why you can't attend at this event",
    reset_password:
      'Here you can set your new password. Also enter your email address, which you used to get to this page.',
    save_reminder:
      'Unsaved changes! Please save your changes by clicking on the Save button.',
    save_reminder_bottom:
      'Unsaved changes! Please save your changes by clicking on the Save button at the end of this page.',
    saving_error: 'Error while saving data. Please try again.',
    select_possible_event:
      'Select an event if you want to exchange the selected request with one of your events.',
    sent_mail_if_known:
      'We have sent you an email if you have an account with this email address.',
    set_player_settings:
      'After saving, you can change other settings such as jersey number or captain.',
    set_team_settings:
      'After saving, you can change other settings such as coaches or practice times.',
    sort_list_description: 'Tap and hold an item to move it',
    take_over_by: 'Event was taken over by {{user}}.',
    team_changed: 'Team changed',
    transfer_players:
      'Which team do you want to transfer the selected players to? The selected players will be removed from this team.',
    user_consent:
      'I confirm that I have consent to collect/edit this user\'s personal information. If consent is not given, the "Invite member" function can be used.',
    user_consent_2:
      'If consent is not given, the "Invite member" function can be used.',
    user_created_event: '{{user}} created the event',
    user_pending: 'The user has not yet logged into backcourt',
    user_updated_event: '{{user}} made a change',
  },
  load_more: {
    comments: 'Load older comments',
    events: 'Load older events (until {{date}})',
    messages: 'Load older messages',
    notifications: 'Load older notifications',
    switch_requests: {
      show: 'Show accepted requests',
      hide: 'Hide accepted requests',
    },
  },
  marketing_texts: {
    description:
      "Backcourt is your partner during basketball season! Regardless of whether you are a coach, player, referee or organizer, Backcourt unites all of your club's participants in one software.",
    download_app: 'Download App',
    login:
      'With Backcourt you always have an overview of the dates of your basketball club!',
    welcome_to_backcourt: 'Welcome to Backcourt!',
  },
  setting_texts: {
    requireReplyReason: {
      title: 'Specify Reason',
      description: 'Players must provide a reason when cancelling an event',
    },
    allowViewReplies: {
      title: 'Show Attendance Responses',
      description: 'Players can view the attendance responses of teammates',
    },
    defaultYesReply: {
      title: 'Default to Attending',
      description: 'Players are automatically marked as attending by default',
      games: {
        title: '',
        description: 'For games',
      },
      practices: {
        title: '',
        description: 'For practice sessions',
      },
    },
  },
  success: {
    generic: {
      create: 'Entry created.',
      update: 'Entry updated.',
      delete: 'Entry deleted.',
    },
    reset_password:
      'Password reset successfully. You can now log in with your new password.',
    send_welcome_mail: 'Users have been notified.',
  },
  users: {
    deleted_user: {
      firstname: 'Deleted',
      lastname: 'User',
    },
    email_addresses: {
      singular: 'E-mail address',
      plural: 'E-mail addresses',
      add: 'Add e-mail address',
      edit: 'Edit e-mail address',
      delete: 'Delete e-mail address',
      description:
        'Here you can store additional e-mail addresses for the user. These can be used to receive notifications.',
      form: {
        fields: {
          email: 'E-mail address',
          description: 'Description',
          use_for_notifications: 'Use for notifications',
        },
      },
    },
    users: 'Users',
    invitation_links: {
      singular: 'Invitation link',
      generate: 'Generate invitation link',
      valid_until: 'Valid until',
      valid_for: 'Valid for',
      valid_for_all_teams: 'All teams',
      form: {
        team_info:
          'The user will be assigned to this team directly during registration. This field is optional.',
      },
    },
    user_data: {
      title: 'User data',
      update: {
        admin_info:
          'Please contact an administrator or coach to update your user data.',
      },
    },
  },
  users_importer: {
    alternative_ctrl_v:
      'Alternatively, you can copy the content of the CSV and simply paste it here using Ctrl+V.',
    auto_activate:
      'Activate newly added users after import and send automatic welcome email?',
    auto_activate_title: 'Auto activate users',
    columns_must_match: 'Number of columns must match!',
    columns_not_matching:
      'Number of columns does not match! Expected: {{expected}} Found: {{received}}. This row cannot be displayed in the preview table.',
    continue_with: 'Continue with {{number}} rows',
    csv_separator: 'CSV separator',
    drop_csv_here: 'Please drop CSV in this field.',
    num_of_users: 'Number of users',
    num_of_valid_rows: 'Of {{total}} inserted rows are {{valid}} correct.',
    step_0: 'Select columns',
    step_1: 'Paste data',
    step_2: 'Settings',
    step_3: 'Check',
    hint_own_fields:
      'Hint: You can define your own fields in the club settings.',
  },
  user_invitation: {
    copied_to_clipboard: 'Link copied to clipboard',
    warning:
      'Attention: With this link people can register with Backcourt! So be careful who you forward the link to.',
  },
  weekdays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
};
